export const SESSION_EXPIRED_EVENT = 'marketplace:session-expired';

let isSessionGuardInitialized = false;

const shouldEmitSessionExpired = (response: Response, requestUrl: string): boolean => {
    if (response.status !== 401) {
        return false;
    }

    return !requestUrl.includes('/api/auth/login');
};

export const setupSessionGuard = (): void => {
    if (isSessionGuardInitialized) {
        return;
    }

    const originalFetch = window.fetch.bind(window);

    window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
        const response = await originalFetch(input, init);
        const requestUrl = typeof input === 'string'
            ? input
            : input instanceof URL
                ? input.toString()
                : input.url;

        if (shouldEmitSessionExpired(response, requestUrl)) {
            window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
        }

        return response;
    };

    isSessionGuardInitialized = true;
};
